export const downloadAsBpmnFile = (data: BlobPart[], name: string) => {
  const blob = new Blob(data, {
    type: "application/bpmn",
  });
  const url = URL.createObjectURL(blob);

  const a = document.createElement("a");
  a.href = url;
  a.download = `${name}.bpmn`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};
